



















































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import Menu, { MenuModel } from '@/models/menu';
import { Dictionary } from 'vue-router/types/router';
import { AppStore } from '@/store/modules/app';
import { UserStore } from '@/store/modules/user';
import { Route } from 'vue-router';
import Utils from '../utils/utils';
import { getModuleName } from '@/utils/utils';
import { getModuleIndex } from '@/utils/utils';

@Component
export default class AppDrawer extends Vue {
  @Prop({ default: true })
  expanded!: boolean;
  mini: boolean = false;
  drawer: boolean = true;
  menus: Array<MenuModel> = Menu;
  created() {}
  get sideBar() {
    return AppStore.sidebar;
  }
  scrollSettings = {
    maxScrollbarLength: 160
  };

  /**获取跳转链接 */
  getItemTarget(item: MenuModel, subItem: MenuModel): object {
    if (subItem.component) {
      return { name: subItem.component };
    }
    return { name: `${item.permissionName}/${subItem.name}` };
  }

  /**关闭菜单 */
  handleClose() {
    this.menus.forEach((v, i, arr) => {
      let items = v.items;
      if (items != undefined) {
        v.active = false;
        items.forEach(e => {
          let subItem = e.items;
          if (subItem != undefined) {
            e.active = false;
          }
        });
      }
    });
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  isShowMenu(item: MenuModel): boolean {
    if (UserStore.isAdmin || UserStore.isSuperAdmin) {
      return true;
    }
    if (UserStore.permissions) {
      if (item.permissionName) {
        return Utils.isPermission(item.permissionName);
      }
      if (item.items) {
        return this.checkChildMenuPermission(item);
      }
    }
    return false;
  }

  checkChildMenuPermission(item: MenuModel): boolean {
    for (let i = 0; i < item.items.length; i++) {
      const subMenuItem = item.items[i];
      if (subMenuItem.permissionName) {
        return Utils.isPermission(subMenuItem.permissionName);
      } else if (subMenuItem.items && subMenuItem.items.length) {
        return this.checkChildMenuPermission(subMenuItem);
      }
    }
    return false;
  }

  checkActiveMenu(menu: MenuModel, routeName: string): boolean {
    for (let i = 0; i < menu.items.length; i++) {
      const subMenuItem = menu.items[i];
      if (subMenuItem.name == routeName) {
        return true;
      } else if (subMenuItem.items && subMenuItem.items.length) {
        return this.checkActiveMenu(subMenuItem, routeName);
      }
    }
    return false;
  }

  @Watch('$route')
  watchRouteChanges(val: Route, oldVal: Route) {
    const name = this.$route.name as string;
    this.menus.forEach((v, i) => {
      const items = v.items;
      if (items != undefined) {
        if (this.checkActiveMenu(v, name)) {
          if (getModuleName(val.name as string) !== getModuleName(oldVal.name as string)) {
            if (
              (val.name == 'capitalAccount' && oldVal.name == 'incomeExpenditureDetail') ||
              (val.name == 'incomeExpenditureDetail' && oldVal.name == 'capitalAccount') ||
              (val.name == 'capitalAccount' && oldVal.name == 'rechargeList') ||
              (val.name == 'rechargeList' && oldVal.name == 'capitalAccount') ||
              (val.name == 'shipmentManagement' && oldVal.name == 'orderList_details') ||
              (val.name == 'orderList_details' && oldVal.name == 'shipmentManagement') ||
              (val.name == 'stockDetail' && oldVal.name == 'productStock') ||
              (val.name == 'productStock' && oldVal.name == 'stockDetail') ||
              (val.name == 'allocation_index' && oldVal.name == 'orderList_details') ||
              (val.name == 'orderList_details' && oldVal.name == 'allocation_index')||
              (val.name == 'stockDetail' && oldVal.name == 'stock_report')||
              (val.name == 'stock_report' && oldVal.name == 'stockDetail')        
            ) {
               Utils.clearPage(this.$route.name as string);
            } else {
              Utils.clearAllSearchPage(this.$route.name as string);
            }
          }
          v.active = true;
        }
        items.forEach(c => {
          let subItems = c.items;
          if (subItems != undefined) {
            if (this.checkActiveMenu(c, name)) {
              c.active = true;
              v.active = true;
            }
          }
        });
      }
    });
    // var splitPath = this.$route.path.split('/');
    // this.menus.forEach((v, i, arr) => {
    //   let items = v.items;
    //   if (items != undefined) {
    //     if (this.checkActiveMenu(v, splitPath[2])) {
    //       v.active = true;
    //     }
    //     items.forEach(c => {
    //       let subItems = c.items;
    //       if (subItems != undefined) {
    //         if (this.checkActiveMenu(c, splitPath[3])) {
    //           c.active = true;
    //           v.active = true;
    //         }
    //       }
    //     });
    //   }
    // });
  }
}
